/*=========================================================================================
  File Name: moduleDataList.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTransactionTypeState.js'
import mutations from './moduleTransactionTypeMutations.js'
import actions from './moduleTransactionTypeActions.js'
import getters from './moduleTransactionTypeGetters.js'

export default {
	isRegistered: false,
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
}

